export const DEFAULT_TIMEOUT_MS = 10000;
export const GET_POOL_CONFIGS_TIMEOUT_MS = 180000;
export const GET_WORKERS_TIMEOUT_MS = 60000;
export const THEME_KEY = 'thash-theme';
